const TEXT =
  "MOBILE APP DEVELOPMENT \u2022 WEB APPLICATION DEVELOPMENT \u2022 WEBSITE DEVELOPMENT \u2022 ";

export const Marquee = () => (
  <div
    className="relative border-y border-border-subtle bg-card-dark/60 py-4 sm:py-5 overflow-hidden"
    data-testid="editorial-marquee"
  >
    <div className="flex whitespace-nowrap animate-marquee">
      {[0, 1].map((rep) => (
        <span
          key={rep}
          className="font-grotesk text-sm sm:text-base tracking-[0.15em] text-slate-500 px-4"
        >
          {TEXT.repeat(4)}
        </span>
      ))}
    </div>
    <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-obsidian to-transparent" />
    <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-obsidian to-transparent" />
  </div>
);
